'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import React from 'react';
import { FieldError, UseFormRegister, Path } from 'react-hook-form';

// reusable component that accepts any form type T with a `privacyPolicy` field
export default function PrivacyPolicyCheckBox<T extends { privacyPolicy: boolean }>({
  register,
  errors,
  labelClassName,
}: Readonly<{
  register: UseFormRegister<T>;
  errors: FieldError | undefined;
  labelClassName?: string;
}>) {
  const t = useTranslations('ClubRegistration');
  const internalPagesLinks = useTranslations('internalPagesLinks');
  return (
    <div className="space-y-1">
      <div className="flex space-x-2">
        <input
          id="privacyPolicy"
          type="checkbox"
          aria-invalid={!!errors}
          aria-describedby={errors ? 'privacyPolicy-error' : undefined}
          {...register('privacyPolicy' as Path<T>)}
          className="h-4 w-4 cursor-pointer"
        />
        <label htmlFor="privacyPolicy" className={labelClassName || 'cursor-pointer text-sm text-neutral-60'}>
          {t.rich('PrivacyPolicyCheckBox', {
            dataPrivacyPolicy: (chunks) => (
              <Link className="underline" href={internalPagesLinks('dataPrivacyPolicy')}>
                {chunks}
              </Link>
            ),
          })}
        </label>
      </div>
      {errors && (
        <p id="privacyPolicy-error" className="text-sm text-red">
          {errors.message}
        </p>
      )}
    </div>
  );
}
